
        import '/home/builduser/work/97f164ade279074e/santa-editor/packages/sections/bootstrap/plugins/core/attachLabelPlugin.scss.css.virtualfile';
        module.exports = {"container":"_container_nifuj_1","name":"_name_nifuj_7"};